var React = require('react');

function SearchGo (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_35915","data-name":"Rectangle 35915","width":"6","height":"9","fill":"none","key":0}),React.createElement("g",{"id":"Group_41430","data-name":"Group 41430","transform":"translate(1.833 7.023) rotate(-90)","key":1},React.createElement("path",{"id":"Path_12622","data-name":"Path 12622","d":"M0,0,2.512,2.335,5.023,0","fill":"none","stroke":"#5a5a5a","strokeLinecap":"round","strokeWidth":"1.5"}))]);
}

SearchGo.defaultProps = {"id":"Group_44766","data-name":"Group 44766","width":"6","height":"9","viewBox":"0 0 6 9"};

module.exports = SearchGo;

SearchGo.default = SearchGo;
